const features = [
  {
    icon: 'ri-flashlight-line',
    title: '秒开无卡顿',
    desc: '分布式CDN加速配合智能调度，确保在任何网络环境下都能实现不缓冲秒开播放，看片零等待。',
    color: 'primary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费不收费',
    desc: '所有内容完全免费在线观看，无需注册、无需会员，零门槛畅享高清影视体验，免费是永远的承诺。',
    color: 'accent',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P高清播放，画面清晰细腻。自适应码率技术根据网络状况智能调节，流畅与画质兼得。',
    color: 'secondary',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时更新',
    desc: '每日同步最新影视资源，热门新片首播后数小时内上线。电影电视剧全集随时观看，永不剧荒。',
    color: 'primary',
  },
];

const colorConfig: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-500/5', text: 'text-primary-400', iconBg: 'bg-primary-500/10' },
  accent: { bg: 'bg-accent-500/5', text: 'text-accent-400', iconBg: 'bg-accent-500/10' },
  secondary: { bg: 'bg-secondary-500/5', text: 'text-secondary-400', iconBg: 'bg-secondary-500/10' },
};

export default function SectionFeatures() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-400">为什么选择春色影视在线观看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feat, i) => {
            const c = colorConfig[feat.color];
            return (
              <div
                key={i}
                className={`text-center p-6 md:p-7 rounded-lg border border-background-300/20 ${c.bg} hover:border-primary-500/20 transition-colors cursor-default`}
              >
                <span className={`inline-flex w-12 h-12 md:w-14 md:h-14 items-center justify-center rounded-lg ${c.iconBg} mb-4`}>
                  <i className={`${feat.icon} ${c.text} text-xl md:text-2xl`}></i>
                </span>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 mb-2">
                  {feat.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}